"use strict";

import angular from "angular";

/**
 * @component NuStep
 * O <nu-step> é um componente para step
 */

import template from "./step.component.html";
import "./themes/step.component.scss";
import "./themes/step.component-dark.scss";

const name = "nuStep";
const def = {
    bindings: {
        index: "=",
        label: "=",
        disabled: "=",
        isSelected: "=",
        isLast: "=",
        action: "="
    },
    controllerAs: "stepCtrl",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
